<template lang="pug">
  v-container(fluid class="py-0")
    v-row(justify="center")
      v-col(cols="9" class="py-0 pl-10 pr-0")
        v-form(ref="form", @submit.prevent="addComplex")
          v-row(no-gutters justify="start")
            v-btn(icon color="black" class="mr-3" @click="onCancel")
              v-icon arrow_back
            Title(titleName="Создание нового комплекса", class="mb-10")
          v-row(no-gutters class="mb-4")
            v-col
              v-text-field(
                :rules="[v => !!v || 'Укажите название комплекса']",
                validate-on-blur,
                v-model="complexItem.name",
                label="Название",
                placeholder="Укажите название комплекса",
                outlined,
                dense)
              v-textarea(
                :rules="[v => !!v || 'Укажите описание комплекса']",
                outlined,
                v-model="complexItem.description",
                label="Описание",
                placeholder="Опишите комплекс",
                validate-on-blur)
          Subtitle(subtitle-name="Дополнительно")
          ExtraItems(:currencyList="currencyList", @set-fields="setFields", class="mb-10")
          Subtitle(subtitle-name="Телефон")
          v-row(class="mb-4")
            v-col(cols="4")
              v-text-field(
                :rules="phoneRules",
                autocomplete="off",
                v-mask="phoneMask",
                v-model="complexItem.phone",
                label="Номер телефона",
                placeholder="(555) 12-34-56",
                outlined,
                dense,
                validate-on-blur)
            v-col(cols="3")
          Address(
            @set-city-id="setCityId",
            @set-district-id="setDistrictId",
            @set-address="setAddress",
            class="mb-10")
          Subtitle(subtitle-name="Статус объекта")
          v-row(no-gutters align="center")
            v-radio-group(v-model="complexItem.built" row :mandatory="false")
              v-radio(label="Построено" :value="true" color="#07f")
              v-radio(label="Строится" :value="false" color="#07f")
            v-row(v-if="!complexItem.built")
              v-text-field(
                style="max-width: 100px; margin-left: 25px;",
                v-model.number="complexItem.quarterFinish",
                type="number",
                placeholder="Квартал",
                outlined,
                dense,
                hide-details)
              v-text-field(
                style="max-width: 100px; margin-left: 15px;",
                v-model.number="complexItem.yearFinish",
                type="number",
                placeholder="Год",
                outlined,
                dense,
                hide-details)
          UploadImages(@set-files="setFiles")
          Subtitle(subtitle-name="Ссылка на видео")
          v-row(no-gutters class="mb-4")
            v-text-field(
              v-model="complexItem.videoUrl"
              placeholder="https://www.youtube.com/watch?v=Idw3g1HK817"
              outlined,
              dense)
          v-row(justify="center" class="mb-10")
            v-btn(large outlined width="200" class="mr-6" style="border-color:#c7c7c7", @click="onCancel") Отмена
            v-btn(large width="200" color="#07f" dark, type="submit", :loading="loading") Создать комплекс
</template>
<script>
import Title from '../../components/Adverts/AddNew/Title'
import Subtitle from '../../components/Complex/Subtitle'
import Address from '../../components/Adverts/AddNew/Address'
import ExtraItems from '../../components/Complex/ExtraItems'

import { mapState } from 'vuex'
import { mask } from 'vue-the-mask'

export default {
  name: 'ComplexAdd',
  directives: {
    mask
  },
  components: {
    ExtraItems,
    Address,
    Subtitle,
    Title,
    UploadImages: () => import('../../components/common/UploadImages')
  },
  data: () => ({
    complexItem: {
      name: null,
      description: null,
      address: null,
      cityId: null,
      districtId: null,
      built: true,
      quarterFinish: null,
      yearFinish: null,
      videoUrl: null,
      phone: null
    },
    loading: false,
    images: [],
    fields: {},
    phoneMask: '996(###)##-##-##',
    phoneRules: [
      v => !!v || 'Необходимо ввести номер телефона',
      v => (v && v.length > 15) || 'Введите правильный номер телефона'
    ]
  }),
  mounted() {
    this.$store.dispatch('GET_CURRENCY_LIST')
  },
  watch: {},
  computed: {
    ...mapState({
      userCompany: state => state.userCompany,
      currencyList: state => state.currencyList,
      coords: state => state.markerCoords
    })
  },
  methods: {
    setFiles(images) {
      this.images = images
    },
    setFields(fields) {
      const result = {}
      for (let el in fields) {
        if (fields[el]) result[el] = fields[el]
      }
      this.fields = result
    },
    createFormData(id) {
      const media = new FormData()
      media.append('id', id)
      this.images.map(item => {
        media.append('images', item.file)
      })
      return media
    },
    async uploadImages(complexId) {
      const formData = await this.createFormData(complexId)
      const response = await this.$store.dispatch('UPLOAD_IMAGES', formData)
      this.loading = false
      if (response.error) console.log('error: ', response.error.message)
      return response
    },
    async addComplex() {
      if (this.$refs.form.validate()) {
        this.complexItem.phone = this.complexItem.phone.replace(/[^0-9]/g, '')
        this.loading = true
        let complexId = null
        const payload = {
          companyId: this.userCompany.companyId,
          point: {
            latitude: this.coords.latitude,
            longitude: this.coords.longitude
          },
          ...this.complexItem,
          ...this.fields
        }

        const response = await this.$store.dispatch('ADD_COMPLEX', payload)
        if (response.error) {
          this.loading = false
          return
        }
        complexId = response.complexId

        const result = await this.uploadImages(complexId)
        if (result.error) {
          this.loading = false
          return
        }

        const updateResponse = await this.$store.dispatch('ADD_COMPLEX', {
          ...payload,
          complexId: complexId,
          photos: result.images
        })
        this.loading = false
        if (updateResponse) {
          await this.$router.push({ path: '/profile/complexes' })
        }
      }
    },
    onCancel() {
      this.$router.push({ path: '/profile/complexes' })
    },
    setCityId(value) {
      this.complexItem.cityId = value
    },
    setDistrictId(value) {
      this.complexItem.districtId = value
    },
    setAddress(value) {
      this.complexItem.address = value
    }
  }
}
</script>
